// import React from "react";
// import { Outlet } from "react-router-dom";
// import { Box, Container } from "@mui/material";
// import Navbar from "./Navbar";

// const Layout = () => {
//   console.log("Layout rendering"); // Should log on every route change
//   return (
//     <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
//       <Navbar />
//       <Container
//         component="main"
//         maxWidth="xl"
//         sx={{
//           mt: 4,
//           mb: 4,
//           flex: 1,
//           display: "flex",
//           flexDirection: "column",
//         }}
//       >
//         <Outlet />
//       </Container>
//     </Box>
//   );
// };

// export default Layout;

// src/components/Layout.jsx

import React, { useState, useCallback } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Box, Container, Toolbar } from "@mui/material";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";

const DRAWER_WIDTH = 260;
const MINI_WIDTH = 72;

const Layout = () => {
  const { pathname } = useLocation();
  /** Farm onboarding: no tenant-scoped nav until an organization exists */
  const hideSidebar = pathname === "/create-farm";

  const [mini, setMini] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const toggleMini = useCallback(() => setMini((m) => !m), []);
  const openMobile = useCallback(() => setMobileOpen(true), []);
  const closeMobile = useCallback(() => setMobileOpen(false), []);

  const sidebarWidth = mini ? MINI_WIDTH : DRAWER_WIDTH;

  return (
    // 1) TOP-LEVEL COLUMN
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      {/* Fixed AppBar on top */}
      <Navbar onOpenSidebar={hideSidebar ? undefined : openMobile} />

      {/* 2) CONTENT ROW: Sidebar + Main */}
      <Box sx={{ display: "flex", flex: 1, width: "100%", minWidth: 0 }}>
        {/* Sidebar column — hidden during create-farm onboarding */}
        {!hideSidebar && (
          <Box
            component="nav"
            sx={{
              width: { md: sidebarWidth },
              flexShrink: { md: 0 },
            }}
          >
            <Sidebar
              openMini={mini}
              onToggleMini={toggleMini}
              mobileOpen={mobileOpen}
              onCloseMobile={closeMobile}
            />
          </Box>
        )}

        {/* Main content */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            minWidth: 0,
            maxWidth: "100%",
            overflowX: "hidden",
          }}
        >
          {/* Spacer equal to AppBar height so content starts below it */}
          <Toolbar sx={{ minHeight: { xs: 66, sm: 74 } }} />
          <Container
            maxWidth="xl"
            disableGutters
            sx={{
              px: { xs: 1.5, sm: 2, md: 3 },
              py: { xs: 2, sm: 3 },
              flex: 1,
              display: "flex",
              flexDirection: "column",
              minWidth: 0,
              maxWidth: "100%",
            }}
          >
            <Outlet />
          </Container>
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
